import { render, staticRenderFns } from "./SimulacaoFinalizar.vue?vue&type=template&id=d4b49832"
import script from "./SimulacaoFinalizar.vue?vue&type=script&lang=js"
export * from "./SimulacaoFinalizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports